import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InputSwitch } from "primereact/inputswitch";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { getCertificateRequests, approveCertificateRequest } from '../../../apis/services';
import { Button } from "primereact/button";
import { Modal } from 'react-bootstrap';

const CertificateRequests = () => {
    const { t } = useTranslation();
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [instructorCourses, setInstructorCourses] = useState([]);
    const [showApprove, setShowApprove] = useState({ show: false, item: {} });
    const [grade, setGrade] = useState();
    useEffect(() => {
        loadInstructorOnlineCourses();
    }, []);
    const loadInstructorOnlineCourses = async () => {
        try {
            const res = await getCertificateRequests();
            setInstructorCourses(res.data.requests);
        } catch (error) {
            console.log(error);
        }
    }
    const handleApproveCertificateRequest = async () =>{
        try {
            let data = {
                id:showApprove.item.id,
                grade:grade,
            }
            await approveCertificateRequest(data);
            loadInstructorOnlineCourses();
            setShowApprove({show:false,item:{}});
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div className="p-3 glass-card">
            <Modal
                show={showApprove.show}
            >
                <div className="p-3">
                    <h5 className="mb-3">{t('approv_certificate')}</h5>
                    <form action="" method="post"
                        onSubmit={(e)=>{
                            e.preventDefault();
                            handleApproveCertificateRequest();
                        }}
                    >
                        <input type="text" className="form-control" required placeholder={t('grade')}
                            value={grade}
                            onChange={(e) => {
                                setGrade(e.target.value)
                            }}
                        />
                        <div className="mt-3">
                            <Button label={t('approve')}
                            />
                            <Button label={t('close')} outlined className="mx-2" type="button"
                                onClick={() => {
                                    setShowApprove({
                                        showL: false,
                                        item: {}
                                    });
                                }}
                            />
                        </div>
                    </form>
                </div>
            </Modal>
            <div className="d-flex jcsb">
                <div className='mt-2 mb-2'>
                    <h4>{t('certificate_requests')}</h4>
                </div>
            </div>

            <div className="data-table mt-2">
                <DataTable
                    value={instructorCourses}
                    paginator
                    rows={10}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[10, 25, 50]}
                    dataKey="id"
                    selectionMode="checkbox"
                    filterDisplay="menu"
                    emptyMessage={t('data_not_available')}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    filters={filters}
                    header={
                        <div className='row'>
                            <div className="col-md-6">
                                <input className='form-control'
                                    placeholder={t('search')}
                                    onChange={(e) => {
                                        let _filters = { ...filters };
                                        _filters['global'].value = e.target.value;
                                        setFilters(_filters);
                                    }}
                                />
                            </div>

                        </div>
                    }
                >
                    <Column
                        field="id"
                        header={t('course_id')}
                        body={(r) => (
                            <span>TC_00{r.course_id}</span>
                        )}
                        sortable
                    />
                    <Column
                        field="course"
                        header={t('course_title')}
                        sortable
                    />
                    <Column
                        field="student_name"
                        header={t('student')}
                        sortable
                    />
                    <Column
                        field="cid"
                        header={t('civil_id')}
                        sortable
                    />
                    <Column
                        field="duration"
                        header={t('duration')}
                        sortable
                    />
                    <Column
                        field="start"
                        header={t('start_date')}
                        sortable
                    />
                    <Column
                        field="end"
                        header={t('end_date')}
                        sortable
                    />
                    <Column
                        field="grade"
                        header={t('grade')}
                        sortable
                    />
                    <Column
                        field="approved"
                        header={t('approved')}
                        sortable
                        body={(r) => <InputSwitch checked={r.approved === 1} />}
                    />
                      <Column
                        field="issued"
                        header={t('issued')}
                        sortable
                    />
                    

                    <Column
                        field="duration"
                        header={t('duration')}
                        sortable
                        body={(r) => <span>{r.duration}</span>}
                    />

                    <Column
                        header={t('actions')}
                        body={(row) => {
                            return (
                                <div className='d-flex'>
                                    <Button
                                        label={t('approve')}
                                        onClick={() => {
                                            setShowApprove({
                                                show: true,
                                                item: row
                                            });
                                        }}
                                    />
                                </div>
                            );
                        }}
                    />
                </DataTable>
            </div>
        </div>
    );
}

export default CertificateRequests;